import { axios } from "../connection/ConnectionHandler";
import { API } from "../constants/api";
import { keyBy } from "lodash";
import {
    ADD_NEW_SINGUP,
    DELETE_SINGUP,
    SINGUP_FORM_TOOGLE_LOADING,
    SET_SINGUP_LIST,
    SHOW_NOTIFICATION,
    UPDATE_SINGUP,
} from "../constants";
import { formatSingUps } from "./settingsActionsUtils";
import moment from "moment";

const SINGUP_REQUEST_TIMEOUT = 20000;
const SINGUP_LIST_TIMEOUT = 30000;

const isSuccessfulResponse = (response) => response && response.status >= 200 && response.status < 300 && response.data && response.data._id;

/* SINGUP LIST */
export const fetchSingUps = () => {
    return async (dispatch) => {
        const response = await axios
            .get(API.singUps.list, { timeout: SINGUP_LIST_TIMEOUT })
            .then((response) => {
                // Si la petición falla no se borra la lista que ya teníamos
                if (!response || !Array.isArray(response.data)) {
                    return typeof response === "number" ? response : 0;
                }
                const singUps = formatSingUps(response.data);
                dispatch({
                    type: SET_SINGUP_LIST,
                    payload: keyBy(singUps, "_id"),
                });
                return response.status;
            })
            .catch((err) => err);
        return response;
    };
};

// SINGUPS
export const createSingUp = (newSingUp) => {
    return async (dispatch) => {
        dispatch({ type: SINGUP_FORM_TOOGLE_LOADING });
        const response = await axios
            .post(API.singUps.create, newSingUp, { timeout: SINGUP_REQUEST_TIMEOUT })
            .then((response) => {
                // El interceptor devuelve el código de estado cuando la petición falla
                if (!isSuccessfulResponse(response)) {
                    dispatch({ type: SINGUP_FORM_TOOGLE_LOADING });
                    return typeof response === "number" ? response : 0;
                }
                const singUp = formatSingUps(response.data);
                dispatch({ type: ADD_NEW_SINGUP, payload: singUp });
                dispatch({ type: SINGUP_FORM_TOOGLE_LOADING });
                dispatch({
                    type: SHOW_NOTIFICATION,
                    payload: {
                        show: true,
                        status: "success",
                        message: "Fichaje creado con éxito.",
                    },
                });
                return response.status;
            })
            .catch((err) => {
                dispatch({ type: SINGUP_FORM_TOOGLE_LOADING });
                return err;
            });
        return response;
    };
};

export const updateSingUp = (updatedSingUp) => {
    return async (dispatch) => {
        dispatch({ type: SINGUP_FORM_TOOGLE_LOADING });
        const response = await axios
            .put(`${API.singUps.edit}${updatedSingUp && updatedSingUp._id}`, updatedSingUp, { timeout: SINGUP_REQUEST_TIMEOUT })
            .then((response) => {
                if (!isSuccessfulResponse(response)) {
                    dispatch({ type: SINGUP_FORM_TOOGLE_LOADING });
                    return typeof response === "number" ? response : 0;
                }
                const singUp = formatSingUps(response.data);
                dispatch({ type: UPDATE_SINGUP, payload: singUp });
                dispatch({ type: SINGUP_FORM_TOOGLE_LOADING });
                dispatch({
                    type: SHOW_NOTIFICATION,
                    payload: {
                        show: true,
                        status: "info",
                        message: "Fichaje actualizado.",
                    },
                });
                return response && response.status;
            })
            .catch((err) => {
                dispatch({ type: SINGUP_FORM_TOOGLE_LOADING });
                return err;
            });
        return response;
    };
};

export const deleteSingUps = (Ids) => {
    return async (dispatch) => {
        dispatch({ type: SINGUP_FORM_TOOGLE_LOADING });
        const response = await axios
            .delete(`${API.singUps.delete}`, { data: Ids })
            .then((response) => {
                dispatch({ type: DELETE_SINGUP, payload: Ids });
                dispatch({ type: SINGUP_FORM_TOOGLE_LOADING });
                dispatch({
                    type: SHOW_NOTIFICATION,
                    payload: {
                        show: true,
                        status: "info",
                        message: "Fichaje eliminado.",
                    },
                });
                return response && response.status;
            })
            .catch((err) => {
                dispatch({ type: SINGUP_FORM_TOOGLE_LOADING });
                return err;
            });
        return response;
    };
};

export const exportSingUpsToExcel = (startDate, endDate, userIds) => {
    return async (dispatch) => {
        dispatch({ type: SINGUP_FORM_TOOGLE_LOADING });
        const response = await axios
            .post(API.singUps.export, {
                startDate,
                endDate,
                userIds
            }, {
                responseType: 'blob'
            })
            .then((response) => {
                const fileName = `fichajes_${moment().format('YYYY-MM-DD_HH-mm')}.xlsx`;

                const url = window.URL.createObjectURL(response.data);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                link.remove();

                dispatch({ type: SINGUP_FORM_TOOGLE_LOADING });
                dispatch({
                    type: SHOW_NOTIFICATION,
                    payload: {
                        show: true,
                        status: "success",
                        message: "Excel exportado con éxito.",
                    },
                });
                return response;
            })
            .catch((err) => {
                dispatch({ type: SINGUP_FORM_TOOGLE_LOADING });
                dispatch({
                    type: SHOW_NOTIFICATION,
                    payload: {
                        show: true,
                        status: "error",
                        message: "Error al exportar el Excel.",
                    },
                });
                return err;
            });
        return response;
    };
};
